module.exports = __webpack_public_path__ + "static/img/Jake-Simpkin.8511083.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jake-Simpkin.jpg
// module id = e8x1
// module chunks = 0